var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"view mb-1",attrs:{"variant":"action-table-doorder"},on:{"click":function($event){return _vm.clickViewOrderRow(_vm.order.id)}}},[_c('img',{staticClass:"view-icon",attrs:{"src":require("@/assets/images/doorder/view-icon.png"),"alt":"view icon"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63454fe8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/doorder/orders/datatable_custom_cells/ViewOrder.vue
// module id = null
// module chunks = 